// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__1vLtK","calendarButtons":"ClockData_calendarButtons__gkpl9"};